export const SEARCH_PROVIDER_INIT_ASSET_SEARCH = '@@searchProvider/initAssetSearch';
export const SEARCH_PROVIDER_INIT_COMBINED_ASSET_SEARCH = '@@searchProvider/initCombinedAssetSearch';
export const SEARCH_PROVIDER_INIT_EVENT_SEARCH = '@@searchProvider/initEventSearch';
export const SEARCH_PROVIDER_INIT_COMBINED_EVENT_SEARCH = '@@searchProvider/initCombinedEventSearch';
export const SEARCH_PROVIDER_TRIGGER_INIT = '@@searchProvider/initAssetSearch';
